export function getWebPUrl(url) {
    let regExp = /\.(jpe?g|jpg|png)$/;

    if (regExp.test(url)) {
        return url.replace(regExp, '.webp');
    }

    return url;
}



// WEBPACK FOOTER //
// ./js/main/package/get-webp-url.js